module.exports = __webpack_public_path__ + "assets/images/no-image/product.a784e329105bb8baa0dcdd3df42d3e6b.webp";